import { useEffect } from 'react';
import { useNotifications } from '@sportschool/shared-logic';

/**
 * Synchronizes the unread notifications count with the mobile application badge (Expo / React Native)
 * and the Web App Badging API (PWA / Chrome / Safari / Edge).
 */
export function useAppBadgeSync(schoolId?: string) {
  const { data: notifications } = useNotifications(schoolId ?? '');

  useEffect(() => {
    if (!notifications || typeof window === 'undefined') return;

    const unreadCount = notifications.filter((n) => !n.isRead).length;

    // 1. Sync badge with React Native mobile app wrapper
    const rnWebView = (window as unknown as { ReactNativeWebView?: { postMessage: (msg: string) => void } }).ReactNativeWebView;
    if (rnWebView) {
      try {
        rnWebView.postMessage(
          JSON.stringify({ type: 'SET_BADGE_COUNT', count: unreadCount })
        );
      } catch (e) {
        console.error('Failed to post badge count message to mobile wrapper:', e);
      }
    }

    // 2. Sync badge with Web App Badging API (PWA / Desktop / Mobile browser)
    if (typeof navigator !== 'undefined' && 'setAppBadge' in navigator) {
      try {
        if (unreadCount > 0) {
          navigator.setAppBadge(unreadCount).catch(() => {});
        } else {
          navigator.clearAppBadge().catch(() => {});
        }
      } catch {
        // Ignore unsupported or restricted environment errors
      }
    }
  }, [notifications]);
}
